import { useQuery } from '@tanstack/react-query';

import { getRetryDelay, shouldRetryRequest } from '@/shared/lib/query/retryConfig';

import { getProjectsExperiments, type GetProjectsExperimentsParams } from '@/entities/experiment/api';
import type { ProjectsExperimentsResponse } from '@/entities/experiment/domain/types';

export const PROJECTS_EXPERIMENTS_QUERY_KEY = 'projects-experiments';

export const useProjectsExperiments = (params?: GetProjectsExperimentsParams, enabled = true) => {
  const result = useQuery<ProjectsExperimentsResponse>({
    queryKey: [PROJECTS_EXPERIMENTS_QUERY_KEY, params],
    queryFn: () => getProjectsExperiments(params),
    enabled,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    retry: shouldRetryRequest,
    retryDelay: getRetryDelay,
  });

  return result;
};
